import styled from 'styled-components';

export const MainWrapperS = styled.section`
  min-height: calc(100vh - 211px);
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
`;

export const WarningS = styled.div`
  gap: 10px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 1rem;
  margin-bottom: 20px;
  color: #664d03;
  background-color: #fff3cd;
  border: 1px solid #ffecb5;
  border-radius: 0.375rem;

  a {
    border-bottom: 1px solid !important;
    color: #2b79d9 !important;
    border-color: rgba(43, 121, 217, 0.2) !important;
    text-decoration: none !important;
    background: rgba(0, 0, 0, 0) !important;
    cursor: pointer !important;
  }
`;
